<template>
	<div>
		<div :class="product.status === 1 ? 'publish_tag' : 'draft_tag'">{{getStatus(product.status)}}</div>
		<div :class="container_class">
			<div class="image">
				<img :src="product.image.feature.Location" />
			</div>

			<div class="details">
				<h4 class="name">{{product.name}}</h4>
				<p class="created">created by <span>{{product.added_by_fullname}}</span></p>
				<h4 class="price">{{getProductPrice(product.min_price,product.max_price)}}</h4>
				<p :class="isStockAvailable ? stockAvailable : stockNotAvailable">{{getStockAvailable(product)}}</p>
				<p class="desc">{{product.description}}</p>
				<ul class="info mt-5">
					<li>
						<feather-icon icon="ShoppingCartIcon" svgClasses="h-5 w-5" /> <span> {{ product.is_shipping_free === 1 ? 'Free Shipping' : 'Shipping Not Included'}} </span>
					</li>
					<li>
						<feather-icon icon="BoxIcon" svgClasses="h-5 w-5" /> <span> {{ product.condition === 1 ? 'New Product' : 'Used Product' }} </span>
					</li>
				</ul>
				<vs-divider></vs-divider>
				<div class="variant">
					<div v-if="product.variant.length > 0">
						<h6>{{product.variant[0].label}}</h6>
						<ul>
							<li v-for="(option,index) in product.variant" :key="index"><vs-chip>{{option.value}}</vs-chip></li>
						</ul>
						<h6 class="mt-8" v-if="product.variant[0].option.length > 0">{{product.variant[0].option[0].label}}</h6>
						<ul v-if="product.variant[0].option.length > 0">
							<li v-for="(option,index) in product.variant[0].option" :key="index"><vs-chip>{{option.value}}</vs-chip></li>
						</ul>
					</div>
					<div v-else><span> No variant available. </span></div>
				</div>
				<vs-divider></vs-divider>
				<vs-button class="shadow-md" @click="editProduct(product)">Edit This Product</vs-button>
			</div>
		</div> 
	</div>
</template>

<script>
import router from '@/router'
import FeatherIcon from '../../../components/FeatherIcon.vue'

const dialogs = {
  miss: (error) => {
    return {
      color: "primary", 
      title: "Oppsy, you are missing!",
      text: "Where are you try to go XP",
      accept:() => {
        router.push('/product')
      },
      close:() => {
        router.push('/product')
      }
    }
  }
}

	export default {
	data(){
		return {
			// product: null,
			isStockAvailable: false,
			stockAvailable: 'stock text-success',
			stockNotAvailable: 'stock text-danger',
			isPublish: 'container publish',
			isDraft: 'container draft',
			container_class: null,
		}
	},
	created(){
		if(this.$route.params.product === undefined){
			this.$vs.dialog(dialogs.miss())
		}
	},
	computed:{
		product() {
			return this.$route.params.product
		}
	},
	methods:{
		getProductPrice(){
			if(this.product.min_price === this.product.max_price){
				return "RM"+this.product.min_price.toFixed(2)
			}else{
				return "RM"+this.product.min_price.toFixed(2)+"-RM"+this.product.max_price.toFixed(2)
			}
		},
		getStockAvailable(product){
			if(product.variant.length !== 0){

			}else{
				if(product.product_inventory_count > 0){
					this.isStockAvailable = true
					return 'Available - In Stock'
				}else{
					return 'Not Available - Out Of Stock'
				}
			}
		},
		getVariantInfo(product){
			if(product.variant.length > 0){
				let variant_div = null
				if(product.variant[0].option.length > 0){
					variant_div = '<div><h6>'+product.variant[0].label+'</h6></div>'
				}else{
					
				}
			}else{
				return '<span> No variant available. </span>'
			}
		},
		getStatus(status){
			if(status === 1){
				this.container_class = this.isPublish
				return 'Published'
			}else{
				this.container_class = this.isDraft
				return 'Draft'
			}
		},
		editProduct(product){
			router.push({name: 'edit-product', params: { product}})
		},
	}
}
</script>

<style scoped>
.container{
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 1fr,1fr;
	grid-template-areas: "image details";
	background: #fff;
	border-radius: 10px;
	padding: 2rem;
}

.image{
	grid-area: image;
	max-width: 500px;
	height:auto;
	align-self: center;
}

.details{
	grid-area: details;
	display:grid;
	grid-template-rows: repeat(9,1fr);
	padding: 0 2rem;
	grid-template-areas: 
	"name"
	"created"
	"price"
	"stock"
	"desc"
	"info";
	max-height: 500px;
}

.created{
	grid-area: created;
	align-self: flex-start;
}

span{
	color:#F9278E;
}

.name{
	grid-area: name;
	align-self: flex-end;
}

.price{
	grid-area:price;
	color:#F9278E;
}

.stock{
	grid-area: stock;
}

.desc{
	grid-area:desc;
}

.info{
	grid-area: info;
	align-self: center;
	font-weight: 600;
}

.variant{
	align-self: center;
}

.publish{
	/* outline: #F9278E solid 2px; */
	box-shadow: 0 0 0 3px #F9278E;
}

.draft{
	/* outline: black solid 2px; */
	box-shadow: 0 0 0 3px black;
}

.publish_tag{
	position: absolute;
  right: 30px;
	text-align: right;
	background: #F9278E;
	color: #fff;
	padding: 2px;
	font-weight: 500;
	border-radius: 0 0 0 5px;
	
}

.draft_tag{
	position: absolute;
  right: 30px;
	text-align: right;
	background: black;
	color: #fff;
	padding: 2px;
	font-weight: 500;
	border-radius: 0 5px 0 5px;
}

@media screen and (max-width: 900px) {
	.container{
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		height: 100%;
	}

	.image img{
		max-width: 350px;
		padding-right: 2rem;
	}

	.draft_tag,.publish_tag{
		right: 15px;
	}

}

</style>

